import { loadScript } from 'util/loadScript';

const SCRIPT_ID = 'vimeoApi';

let vimeoApiLoadingPromise;

export function loadVimeoApi() {
    if (vimeoApiLoadingPromise) return vimeoApiLoadingPromise;

    vimeoApiLoadingPromise = new Promise((resolve, reject) => {
        // Check if is already in the DOM
        const existingScript = document.getElementById(SCRIPT_ID);
        if (existingScript) {
            if (window.Vimeo && window.Vimeo.Player) {
                resolve();
            } else {
                existingScript.onload = () => resolve();
                existingScript.onerror = () => reject(new Error('Vimeo API failed to load.'));
            }
            return;
        }

        loadScript('https://player.vimeo.com/api/player.js', SCRIPT_ID);

        const newScript = document.getElementById(SCRIPT_ID);
        if (newScript) {
            newScript.onload = () => {
                if (window.Vimeo && window.Vimeo.Player) {
                    resolve();
                } else {
                    reject(new Error('Vimeo API failed to load.'));
                }
            };

            newScript.onerror = () => reject(new Error('Failed to load the Vimeo API script.'));
        } else {
            reject(new Error('Failed to append the Vimeo API script.'));
        }
    });

    return vimeoApiLoadingPromise;
}
